


































































import Vue, { PropType, VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import cloneDeep from "lodash/cloneDeep";
import VaTableTop from "@/components/molecules/VaTableTop.vue";
import VaNoDataTag from "@/components/molecules/VaNoDataTag.vue";
import dataTableMixin from "@/components/mixins/dataTableMixin";
import { Media, shortMediaConfig } from "@/models/media";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof dataTableMixin>>
).extend({
  name: "MediaPopup",
  mixins: [dataTableMixin],
  components: {
    VaNoDataTag,
    VaTableTop,
    VaButton,
    VaCard,
  },
  mounted() {
    this.groupOptions.itemsPerPage = 5;
  },
  data() {
    return {
      dialog: false,
      storeName: "media",
      tableConfig: shortMediaConfig,
      mutableMedia: cloneDeep(
        this.media
        // this.media.filter((m: Media) => m.fileType != "youtube")
      ),
      tableOptions: {
        page: 1,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: true,
      },
    };
  },
  props: {
    media: {
      required: false,
      type: Array as PropType<Array<Media>>,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    media: function (newVal) {
      this.mutableMedia = cloneDeep(newVal);
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    onChangeMedia(val: Media) {
      if (this.isPresent(val)) {
        this.mutableMedia = this.mutableMedia.filter(
          (m: Media) => m.companyMediaId != val.companyMediaId
        );
      } else {
        this.mutableMedia.push(val);
      }
      this.$emit("onChangeMedia", this.mutableMedia);
    },
    isPresent(media: Media) {
      return this.media.some(
        (m: Media) => m.companyMediaId == media.companyMediaId
      );
    },
  },
  computed: {
    currentMedia(): Media | undefined {
      return this.$store.getters["media/currenMedia"];
    },
    items(): Media[] {
      return this.$store.getters["media/media"];
    },
  },
});
